import React from 'react';
import { LandingPageV4 } from './v4';


export const LandingPageV5: React.FunctionComponent<{ hasLoginSignup?: boolean, hasDisclaimer?: boolean }> = ({ hasLoginSignup = false, hasDisclaimer = false }) => {
  return (
    <LandingPageV4 hasDisclaimer={hasDisclaimer} hasLoginSignup={hasLoginSignup} hasCarousel={true} />
  )
}